
import React from "react";
import { Calendar, Clock, Map, Bell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { ActivityPriority } from "@/components/activities/ActivityPriority";
import { 
  formatActivityDate, 
  formatActivityTime, 
  getReminderLabel 
} from "@/components/activities/utils/activityUtils";
import { Activity } from "@/components/activities/schema/activitySchema";

interface ActivityDetailCardProps {
  activity: Activity;
  parcelName: string | null;
}

export const ActivityDetailCard: React.FC<ActivityDetailCardProps> = ({ 
  activity,
  parcelName
}) => {
  const formattedDate = formatActivityDate(activity.scheduled_for);
  const formattedTime = formatActivityTime(activity.scheduled_for);
  
  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        {activity.description && (
          <div className="mb-4">
            <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line">
              {activity.description}
            </p>
          </div>
        )}

        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-gray-500" />
            <span className="font-medium">{formattedDate}</span>
          </div>
          
          <div className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-gray-500" />
            <span>{formattedTime}</span>
          </div>

          <div className="flex items-center gap-2">
            <ActivityPriority priority={activity.priority} className="!text-sm" />
            <span className="text-sm">Priorité</span>
          </div>

          {activity.parcel_id && parcelName && (
            <div className="flex items-center gap-2">
              <Map className="h-5 w-5 text-gray-500" />
              <span>Parcelle: {parcelName}</span>
            </div>
          )}

          {activity.reminder_time && (
            <div className="flex items-center gap-2">
              <Bell className="h-5 w-5 text-gray-500" />
              <span>Rappel: {getReminderLabel(activity.reminder_time)}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
